import { type ComponentProps, type ChangeEvent, forwardRef } from 'react';
import TextField, { type TextFieldProps } from '@mui/material/TextField';
import { IMaskMixin } from 'react-imask';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const InternalMaskTextField = IMaskMixin((props: any) => (
  <TextField {...(props as unknown as ComponentProps<typeof TextField>)} />
));

const maskPresets = {
  cnpj: {
    mask: '00.000.000/0000-00',
    lazy: true,
    unmask: true,
  },
  cpf: {
    mask: '000.000.000-00',
    lazy: true,
    unmask: true,
  },
  phone: {
    mask: '(00) 00000-0000',
    lazy: true,
    unmask: true,
  },
  cep: {
    mask: '00000-000',
    lazy: true,
    unmask: true,
  },
} as const;

type MaskType = keyof typeof maskPresets;

type BaseMaskProps = ComponentProps<typeof InternalMaskTextField>;

type MaskedInputProps = TextFieldProps &
  Omit<BaseMaskProps, 'maskType'> & {
    maskType?: MaskType;
  };

const getPresetProps = (maskType?: MaskType) => {
  if (!maskType) return {};
  return maskPresets[maskType];
};

export const MaskedInput = forwardRef<HTMLInputElement, MaskedInputProps>(
  ({ maskType, onChange, ...restProps }, ref) => {
    const presetProps = getPresetProps(maskType as MaskType | undefined);
    const handleChange = onChange as TextFieldProps['onChange'];

    return (
      <InternalMaskTextField
        {...presetProps}
        {...restProps}
        onChange={handleChange}
        {...(handleChange && {
          onAccept: (_value: string, maskRef: { value: string }) =>
            handleChange(
              maskRef.value as unknown as ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
            ),
        })}
        inputRef={ref}
      />
    );
  }
);
